import React, { Component } from "react";
import PropTypes from "prop-types";

export class AnalyticsRenderDispatch extends Component {
  componentDidMount () {
    const {
      event, 
      category,
      action, 
      label
    } = this.props;

    let dataLayerEvent = {
      event: event || "GAEvent",
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    };
    
    let hostname = window.location.hostname;
    if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerEvent);
    }
  }

  render () {
    return (
      <>
        {this.props.children}
      </>
    );
  }
}

AnalyticsRenderDispatch.defaultProps = {
  event: "minha.glambox.event", 
  children: null
};

AnalyticsRenderDispatch.propTypes = {
  event: PropTypes.string,
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node
};
